export default "__VITE_ASSET__CMTO$zmk__"